var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "pa-0 ma-0", attrs: { fluid: "" } },
    [
      _c(
        "cards-body",
        {
          attrs: {
            title: _vm.title,
            icon: _vm.icon,
            "no-btn-create": _vm.noBtnCreate,
            "hide-title": _vm.hideTitle,
          },
          on: {
            clickedCreateButton: function ($event) {
              return _setup.emit("clickedCreateButton")
            },
          },
          scopedSlots: _vm._u(
            [
              {
                key: "tools",
                fn: function () {
                  return [_c("v-spacer"), _vm._t("tools")]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }